import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../theme/material.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { Route } from './shell.service';
import { ShellComponent } from './shell/shell.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    ShellComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    MaterialModule,
    RouterModule
  ],
  providers: [
    Route
  ]
})
export class ShellModule { }
